import { useDictionary } from '@adamlip/okeoke.client';
import { Card, CardBody } from '@nextui-org/react';
import { UserContext } from 'contexts/UserContext';
import moment from 'moment';
import { useContext } from 'react';

function ProfileData() {

  const { userData } = useContext(UserContext);
  const { getValue } = useDictionary();

  return (
    <Card className='bg-default'>
      <CardBody>
        <p className='text-lg font-bold'>
          {userData?.firstName} {userData?.lastName}
        </p>
        <p className='text-small mt-2'>Jelenlegi kártya szint:</p>
        <p className='text-lg font-bold'>{userData?.cardTypeName}</p>
        {userData?.insertTimestamp && (
          <div className='font-light text-small opacity-80 w-full text-right'>
            {getValue('vipProfile.datas.registerDate')} {moment(userData?.insertTimestamp).format('YYYY.MM.DD')}
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default ProfileData;
